import ErrorHandler from '../../utils/errorHandler'
import send from '../../utils/fetch'

const actions = {
    async GET_OFFER_LIST({ commit }, id = null) {
        try {
            let response
            if (!id) {
                response = await send(global.$url.settings_offers.get, 'GET')
            } else {
                response = await send(global.$url.offers.get, 'GET', {params: {id}})
            }

            if (response.data.success) {
                commit('SET_LIST', response.data.result)
            }
            return response.data.result
        } catch (e) {
            return Promise.reject(e)
        }
    },

    async GET_ST_OFFERS({commit}) {
        try {
            const {data} = await send(global.$url.offers.all, 'GET')
            commit('SET_LIST', data.result)
            return data.result
        } catch (e) {
            return Promise.reject(e)
        }
    },

    async COMPAIGN_OFFERS({commit}) {
        try {
            const {data} = await send(global.$url.offers.get_offers, 'GET')
            commit('SET_LIST', data.result)
        } catch (e) {
            return new ErrorHandler(e).send
        }
    },

    async UPDATE_STATUS({ dispatch }, {id}) {
        try {
            const {data} = await send(global.$url.settings_offers.destroy, 'DELETE', {data: {id}})
            dispatch('GET_OFFER_LIST')
            return data
        } catch (e) {
            return Promise.reject(e)
        }
    },

    async ADD_OFFERS({ dispatch }, name) {
        try {
            const {data} = await send(global.$url.settings_offers.create, 'POST', {data: {name}})
            dispatch('GET_OFFER_LIST')
            return data
        } catch (e) {
            return Promise.reject(e)
        }
    },

    async UPDATE_OFFER({ dispatch }, {name, id}) {
        try {
            const {data} = await send(global.$url.settings_offers.update, 'PUT', {data: {name, id}})
            dispatch('GET_OFFER_LIST')
            return data
        } catch (e) {
            return Promise.reject(e)
        }
    }
}

export default actions
